var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSensorDeCombustibleContaminado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#175d84;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-sensor-de-combustible-contaminado") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_38_copia_12",
    "data-name": "38 copia 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.41,174.69h-.34a61.22,61.22,0,0,1-8.3-1.43c-10.15-2.51-18.74-7.58-24.86-14.66-7-8.1-10.53-18.37-10.53-30.53,0-16.67,9.33-28.8,16.82-38.54l.23-.3c1.06-1.37,2-2.67,3-4,7.23-9.86,12.61-18.89,12.66-19l8.26-13.91A10.43,10.43,0,0,1,108,51.86l9,13.44c.75,1.11,7.52,11.14,14.49,21l1.64,2.3a3.31,3.31,0,0,1-5.39,3.85l-1.65-2.32c-7-9.9-13.83-20-14.58-21.11l-9-13.44a3.8,3.8,0,0,0-6.44.18L87.81,69.63c-.39.66-5.9,9.82-13,19.52-1,1.38-2.08,2.77-3.11,4.11l-.22.28c-6.89,9-15.46,20.1-15.46,34.52,0,28.2,21.23,36.5,30.36,38.76a53.89,53.89,0,0,0,7.38,1.27,3.31,3.31,0,0,1-.33,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.36,150.75a3.3,3.3,0,0,1-2.31-.94c-12.64-12.29-8.79-30.14-8.62-30.9a3.31,3.31,0,0,1,6.46,1.45c0,.15-3.17,15,6.78,24.71a3.31,3.31,0,0,1-2.31,5.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.36,106.27a2.89,2.89,0,0,1,2.55,1.47L170,156.4a2.94,2.94,0,0,1-2.55,4.41H111.27a2.94,2.94,0,0,1-2.55-4.41l28.09-48.66h0a2.89,2.89,0,0,1,2.55-1.47m0-6.31a9.16,9.16,0,0,0-8,4.62l-28.09,48.67a9.25,9.25,0,0,0,8,13.87h56.19a9.25,9.25,0,0,0,8-13.87l-28.1-48.66a9.14,9.14,0,0,0-8-4.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.19,147.58a4.19,4.19,0,0,1,0,5.68,4.25,4.25,0,0,1-5.66,0,4.16,4.16,0,0,1,0-5.66,3.78,3.78,0,0,1,2.83-1.13A3.83,3.83,0,0,1,142.19,147.58Zm.82-26.44a.54.54,0,0,1,.15.39v22.31a.56.56,0,0,1-.15.39.57.57,0,0,1-.39.16h-6.43a.55.55,0,0,1-.54-.55V121.53a.51.51,0,0,1,.16-.39.49.49,0,0,1,.38-.16h6.43A.53.53,0,0,1,143,121.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSensorDeCombustibleContaminado);
export default __webpack_public_path__ + "static/media/ic-sensor-de-combustible-contaminado.317d0626474a3fbe5eb42353233640dd.svg";
export { ForwardRef as ReactComponent };